export enum LangEnum {
  ES = "es-ES",
}
